import { initBarba } from './barba.js';

console.log('Sixone — Advanced Material Regeneration')

initBarba()